export default "__VITE_ASSET__DP2xAsPN__"